import React, { useEffect, useState } from 'react';
import { apiFetch } from '../../services/apiClient';
import AdminLayout from './AdminLayout';
import AdminAskAI from './AdminAskAI';
import BridgeChat from '../../components/BridgeChat';
import { ASKAI_PROPS } from '../../askaiBridge';

// Desktop /admin/ask. Legacy in-app Ask AI or the external Front Desk bridge,
// per the server ASK_AI_MODE flag (default legacy). Legacy is untouched.
export default function AdminAskAIRoute() {
  const [mode, setMode] = useState(null);
  useEffect(() => { apiFetch('/askai/config').then(d => setMode(d?.mode || 'legacy')).catch(() => setMode('legacy')); }, []);

  if (mode === null) return <AdminLayout><div style={{ color: '#6b7280', padding: '20px 0' }}>Loading…</div></AdminLayout>;
  if (mode !== 'bridge') return <AdminAskAI />;
  return (
    <AdminLayout>
      <div style={{ height: 'calc(100vh - 150px)', maxWidth: 900, margin: '0 auto', display: 'flex', flexDirection: 'column' }}>
        <div style={{ flex: 1, minHeight: 0 }}><BridgeChat {...ASKAI_PROPS} /></div>
      </div>
    </AdminLayout>
  );
}
